export const styles = {
  wrap: {
    display: 'grid',
    gridAutoRows: '80px',
  },
};
